/**
 *
 * Speaker - CVent Block
 *
 * Handling speaker lightbox
 */

jQuery(document).ready(function () {
    const $ = jQuery;
    const cvent = new CVent();


    const speakerBlock = $(".itbl-speakers-cvent");
    const eventCode = speakerBlock.data('event');

    if(!speakerBlock.length) {
        return;
    }

    if(eventCode) {
        cvent.getSpeakers(eventCode).then(speakers => {
            populateSpeakers(speakers);
        }).then(() => {
            // Add lightbox functionality
            $('.itbl-speakers-cvent__speaker').on('click', function () {
                $(this).find('.itbl-speakers-cvent__speaker-content-wrap').toggleClass('active');
            });
        });
    } else {
        return;
    }

    function populateSpeakers(speakers) {
        const $contentWrapper = $('.itbl-speakers-cvent__main-content');

        speakers.forEach(speaker => {
            var $speakerSocial = $(`<div class="itbl-speakers-cvent__speaker-social"></div>`);
            const speakerLinks = speaker.links;

            if(speakerLinks) {
                for (const [key, link] of Object.entries(speakerLinks)) {
                    if(key !== 'profilePicture') {
                        $speakerSocial.append(`
                            <a href="${link.href}" target="_blank" class="itbl-speakers-cvent__speaker-social-link">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                            </a>
                        `);
                    }
                };
            }

            const $speaker = $(`
                <div class="itbl-speakers-cvent__speaker">
                    <div class="itbl-speakers-cvent__speaker-image">
                        <img src="${speaker.profilePicture}" alt="${speaker.firstName} ${speaker.lastName}" />
                    </div>
                    <div class="itbl-speakers-cvent__speaker-info">
                        <h3 class="itbl-speakers-cvent__speaker-name">${speaker.firstName} ${speaker.lastName}</h3>
                        <h4 class="itbl-speakers-cvent__speaker-title">${speaker.title} / <span>${speaker.company}</span></h4>
                    </div>
                    <div class="itbl-speakers-cvent__speaker-content-wrap">
                        <div class="itbl-speakers-cvent__speaker-content grid-y itbl-u-px-2 itbl-u-py-2">
                            <div class="grid-x" style="flex-wrap: nowrap; width: 100%;">
                                <div class="itbl-speakers-cvent__speaker-content-left col-12 col-md-6">
                                    <img width="250" src="${speaker.profilePicture}" alt="${speaker.firstName} ${speaker.lastName}" />
                                </div>

                                <div class="itbl-speakers-cvent__speaker-content-right col-12 col-md-5 medium-offset-1">
                                    <h3 class="itbl-speakers-cvent__speaker-name">${speaker.firstName} ${speaker.lastName}</h3>
                                    <h4 class="itbl-speakers-cvent__speaker-title">${speaker.title} / <span>${speaker.company}</span></h4>

                                    ${$speakerSocial[0].outerHTML}
                                </div>
                            </div>

                            <div class="itbl-speakers-cvent__speaker-content-bio col-12 itbl-u-mt-2">
                                ${speaker.biography}
                            </div>
                        </div>
                    </div>
                </div>
            `);

            $contentWrapper.append($speaker);
        });
    }
});